import { Item } from '@features/campaigns/builder/services/formFields';
import { AdManagerApiResponse } from '@shared/api/commonApiInterfaces';

export const mockedOneflightClientsData: AdManagerApiResponse<Pick<Item, 'id' | 'name'>[]> = {
  items: [
    {
      id: '0224cb28-95ca-463e-adc0-0108b3772913',
      name: 'Client 1',
    },
    {
      id: '1224cb28-95ca-463e-adc0-0108b3772913',
      name: 'Client 2',
    },
    {
      id: '2224cb28-95ca-463e-adc0-0108b3772913',
      name: 'Client 3',
    },
  ],
  meta: {
    itemCount: 3,
    itemsPerPage: 3,
    currentPage: 1,
    totalItems: 3,
    totalPages: 1,
  },
};
